<div class="teams-container">
  <div *ngIf="loading" class="teams-loading">
    <p-progressSpinner strokeWidth="3" [style]="{ width: '36px', height: '36px' }"></p-progressSpinner>
  </div>

  <p-accordion [multiple]="true" *ngIf="!loading">
    <p-accordionTab *ngFor="let group of teamGroups" [selected]="false">
      <ng-template pTemplate="header">
        <div class="team-header">
          <span class="team-name">{{ group.name }}</span>
          <span class="team-count">{{ group.members.length }}</span>
          <button
            type="button"
            class="add-members-btn"
            (click)="openAddModal(group.name, $event)"
            pTooltip="Add members"
            tooltipPosition="top"
          >
            <i class="pi pi-user-plus"></i>
          </button>
        </div>
      </ng-template>

      <p-table
        [value]="group.members"
        styleClass="p-datatable-sm"
        [rowHover]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th class="col-team">Team</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr>
            <td class="cell-name">{{ user.name || '—' }}</td>
            <td class="cell-email">{{ user.email }}</td>
            <td class="cell-team">
              <div class="team-cell-inner">
                <p-dropdown
                  [options]="teamOptions"
                  [ngModel]="user.team"
                  [disabled]="savingUserId === user._id"
                  placeholder="— None —"
                  appendTo="body"
                  styleClass="team-dropdown"
                  (onChange)="onTeamChange(user, group.name, $event.value)"
                ></p-dropdown>
                <i
                  *ngIf="savingUserId === user._id"
                  class="pi pi-spin pi-spinner saving-icon"
                ></i>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="cell-empty">No members assigned to this team.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>
  </p-accordion>
</div>

<!-- Add Members Modal -->
<p-dialog
  [(visible)]="modalVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '520px' }"
  appendTo="body"
  styleClass="add-members-dialog"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <i class="pi pi-users modal-header-icon"></i>
      <span>Add Members to Team</span>
    </div>
  </ng-template>

  <div class="modal-body">
    <div class="modal-field">
      <label class="modal-label">Team</label>
      <p-dropdown
        [options]="teamOptions"
        [(ngModel)]="modalTeam"
        (onChange)="onModalTeamChange()"
        placeholder="Select a team"
        styleClass="modal-team-dropdown"
      ></p-dropdown>
    </div>

    <div class="modal-field">
      <label class="modal-label">
        Users
        <span class="modal-label-hint">{{ selectedUsers.length }} selected</span>
      </label>
      <p-listbox
        [options]="modalUserOptions"
        [(ngModel)]="selectedUsers"
        [multiple]="true"
        [checkbox]="true"
        [filter]="true"
        filterPlaceholder="Search users..."
        optionLabel="label"
        optionValue="value"
        [listStyle]="{ 'max-height': '300px' }"
        styleClass="modal-listbox"
        [emptyMessage]="modalTeam ? 'All users are already in this team.' : 'Select a team first.'"
      ></p-listbox>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <p-button
        label="Cancel"
        styleClass="p-button-text p-button-sm"
        (onClick)="modalVisible = false"
        [disabled]="modalSaving"
      ></p-button>
      <p-button
        label="Add Members"
        icon="pi pi-check"
        styleClass="p-button-sm"
        (onClick)="saveModal()"
        [loading]="modalSaving"
        [disabled]="!selectedUsers.length || !modalTeam"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
